module.exports = __webpack_public_path__ + "img/home-products.a88584ac.png";